import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import {
  AssetDistributionOption, ButtonBar, ScreenHeader
} from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOATaxMatters() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ taxMatters, setTaxMatters ] = useState(powerOfAttorney.tax_matters || false);
  
  useScrollToTop();
  
  const handleBack = useCallback(() => {
    navigate('../insurance-annuity');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      tax_matters: taxMatters
    }));
    navigate('../real-estate');
  }, [ taxMatters, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-tax-matters screen-container screen">
      <ScreenHeader
        title="Tax Matters"
        description="Decide whether to grant your agent power to handle tax matters"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Are Tax Matter Powers?</h3>
        <p>
          Tax matter powers allow your agent to handle all aspects of your 
          tax obligations and dealings with tax authorities. This includes:
        </p>
        <ul className="tax-matters-list">
          <li>Preparing and filing tax returns</li>
          <li>Communicating with the IRS and state agencies</li>
          <li>Handling tax audits and examinations</li>
          <li>Making tax payments and estimated payments</li>
          <li>Claiming refunds and credits</li>
          <li>Appealing tax decisions</li>
          <li>Managing tax planning strategies</li>
        </ul>

        <h3>What Your Agent Can Do</h3>
        <p>If you grant this power, your agent can:</p>
        <ul className="agent-powers">
          <li>File all types of tax returns on your behalf</li>
          <li>Represent you before tax authorities</li>
          <li>Make tax payments and receive refunds</li>
          <li>Hire tax professionals and accountants</li>
          <li>Appeal tax assessments and decisions</li>
          <li>Access your tax records and information</li>
        </ul>

        <h3>Do You Want to Grant This Power?</h3>
        <div className="asset-distribution-option-container">
          <AssetDistributionOption
            id="tax-matters-yes"
            label="Yes"
            description="Grant power to handle tax matters"
            value="yes"
          />
          <AssetDistributionOption
            id="tax-matters-no"
            label="No"
            description="Do not grant power to handle tax matters"
            value="no"
          />
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Tax matters can be complex and have significant financial consequences. 
            The IRS may require Form 2848 (Power of Attorney and Declaration of 
            Representative) for certain tax representations.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
